import { mapValues, isObject } from "lodash-es";
import { Distance, DistanceUnits, Weight, WeightUnits } from "shared/utils";

export const convertDimension = (value: Weight | Distance): number | null => {
  const unit = value instanceof Weight ? WeightUnits.g : DistanceUnits.mm;
  const convertedValue = value.convert(unit).value;

  if (convertedValue !== null) {
    return Math.trunc(convertedValue);
  }

  return null;
};

export const convertDimensions = (formObject: unknown): any => {
  // if weight/distance convert to and return numeric value
  if (formObject instanceof Weight || formObject instanceof Distance) {
    return convertDimension(formObject);
  }

  if (Array.isArray(formObject)) {
    return formObject.map((value: unknown) => convertDimensions(value));
  }

  // if value is still object, iterate deeper to find weight/distance objects
  if (isObject(formObject)) {
    return mapValues(formObject, (value: unknown) => convertDimensions(value));
  }

  // if not an object, return without editing value
  return formObject;
};
